var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _ellipse, _path11, _ellipse2, _circle, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsfLoan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 68V50l-9 18h9z",
    fill: "#E1F8F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 46.063v4.062M37 42v26H10V55",
    stroke: "#376E66",
    strokeWidth: 1.922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 68v.961a.961.961 0 01-.961-.961H37zm-.961-26a.961.961 0 011.922 0h-1.922zM47 67.039a.961.961 0 010 1.922v-1.922zM36.039 68V42h1.922v26h-1.922zM47 68.961H37v-1.922h10v1.922z",
    fill: "#376E66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.216 24.486h28.173L35.36 39.19H7.184l19.03-14.705z",
    stroke: "#376E66",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.085 28H45.5l-5.189 4H21l5.085-4z",
    stroke: "#376E66",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.206 23.776a.96.96 0 10-1.295 1.42l1.295-1.42zm14.06 15.422a.961.961 0 101.294-1.42l-1.295 1.42zM53.91 25.196l15.354 14.002 1.295-1.42-15.354-14.002-1.295 1.42z",
    fill: "#376E66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#376E66",
    strokeWidth: 1.922,
    strokeLinejoin: "round",
    d: "M18.901 48h10.057v9.143H18.901z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32 19c-4.97 0-9 4.014-9 8.965A8.9 8.9 0 0023.96 32h16.08a8.9 8.9 0 00.96-4.035C41 23.014 36.97 19 32 19z",
    fill: "#FFF7EE",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.061 30.825a.961.961 0 10.248 1.906l-.248-1.906zm1.753.464l-.423-.864-.004.002.427.862zm1.155-2.13l.92-.275-.92.275zm-1.247-1.178l.22-.935h-.002l-.218.935zm-1.698.266l.258.926.007-.002-.265-.924zm-1.429.004l-.392.877.006.003.386-.88zm-.955-1.077l-.92.275v.005l.92-.28zm1.155-2.13l.424.862-.424-.862zm1.73.466a.961.961 0 00-.203-1.911l.203 1.911zm-.34 6.268l.125.953h.007l.012-.003a3.078 3.078 0 00.17-.027c.11-.02.262-.05.44-.092.35-.085.833-.227 1.301-.46l-.853-1.722a4.42 4.42 0 01-.898.314 5.342 5.342 0 01-.427.084h-.003.002l.124.953zm2.051.374a3.328 3.328 0 001.357-1.225c.34-.553.525-1.275.296-2.043l-1.841.55c.04.137.024.297-.094.49a1.41 1.41 0 01-.563.502l.845 1.726zm1.654-3.268a2.685 2.685 0 00-1.947-1.838l-.441 1.87c.254.06.47.262.546.517l1.841-.549zm-1.95-1.839c-.484-.112-.931-.057-1.287.022-.316.07-.705.202-.894.256l.53 1.848c.357-.103.53-.171.783-.228.213-.048.341-.047.433-.026l.435-1.872zm-2.173.276c-.425.118-.645.111-.786.05l-.772 1.76c.782.343 1.562.184 2.073.042l-.515-1.852zm-.78.052a.801.801 0 01-.428-.48l-1.838.561c.226.743.78 1.36 1.482 1.674l.784-1.755zm-.426-.474c-.069-.229-.036-.37.026-.48.075-.136.253-.326.633-.513l-.85-1.724c-.606.298-1.14.721-1.463 1.303-.337.606-.39 1.287-.188 1.964l1.842-.55zm.659-.993a4.394 4.394 0 011.307-.396h-.001-.001l-.102-.956-.101-.955h-.002-.002-.004l-.013.002-.04.005a6.287 6.287 0 00-.566.106 6.316 6.316 0 00-1.325.47l.85 1.724z",
    fill: "#7E776E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M28.953 23l.667 1.351",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 28.5L40.207 32H21",
    stroke: "#376E66",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.244 68.6c0 1.119-4.759 2.025-10.629 2.025-5.87 0-10.628-.906-10.628-2.024v-3.037c2.258 0 19.535-.228 21.257 0v3.037z",
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.615,
    cy: 65.564,
    rx: 10.628,
    ry: 2.024,
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.244 62.038c0 1.118-4.759 2.024-10.629 2.024-5.87 0-10.628-.906-10.628-2.024V59c2.258 0 19.535-.229 21.257 0v3.037z",
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.615,
    cy: 59.001,
    rx: 10.628,
    ry: 2.024,
    fill: "#E1F8F1",
    stroke: "#10C98E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.121,
    cy: 48.879,
    r: 9.11,
    fill: "#FFF7EE",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.512 51.425a.961.961 0 00-.625 1.817l.625-1.817zm1.358 1.193l.005-.961h-.005v.96zm1.974-1.39l.947.164-.947-.163zm-.59-1.602l.613-.74-.002-.002-.611.742zm-1.634-.516l-.18.944.007.001.173-.945zm-1.277-.63l-.741.611.004.006.737-.617zm-.375-1.384l-.947-.163v.006l.947.157zm1.975-1.389l-.003.961.003-.96zm1.336 1.186a.96.96 0 10.668-1.802l-.668 1.802zm-3.08 5.44l-.312.909h.002l.005.002a.754.754 0 01.049.017l.127.038c.107.032.256.073.434.113.35.08.844.166 1.365.167l.002-1.922c-.325 0-.666-.056-.94-.119a5.353 5.353 0 01-.419-.113l-.002-.001h.001l-.312.91zm1.665 1.246a3.32 3.32 0 001.756-.492c.549-.344 1.035-.907 1.171-1.695l-1.894-.327c-.024.14-.108.275-.299.394-.201.127-.473.2-.723.198l-.01 1.922zm2.927-2.187a2.678 2.678 0 00-.924-2.506l-1.227 1.48c.2.165.302.44.257.7l1.894.326zm-.926-2.508c-.383-.315-.807-.464-1.16-.551-.313-.077-.718-.133-.911-.168l-.347 1.89c.364.067.548.083.799.144.211.052.325.11.397.168l1.222-1.483zm-2.064-.718c-.43-.082-.623-.185-.72-.302l-1.475 1.233c.547.654 1.314.857 1.834.957l.361-1.888zm-.716-.297a.795.795 0 01-.169-.615l-1.896-.315a2.716 2.716 0 00.582 2.152l1.483-1.222zm-.17-.61c.04-.233.131-.344.235-.415.126-.087.368-.177.79-.176l.006-1.922c-.674-.002-1.339.138-1.886.515-.57.392-.919.978-1.039 1.672l1.894.327zm1.025-.59a4.373 4.373 0 011.342.225h-.001-.001v-.001h-.001l.334-.901.334-.901h-.001l-.002-.002-.005-.001-.012-.005a2.842 2.842 0 00-.163-.053 6.297 6.297 0 00-1.819-.283l-.005 1.921z",
    fill: "#7E776E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.082 53.19v1.542M61.097 43.51l-.003 1.501",
    stroke: "#7E776E",
    strokeWidth: 1.922,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgSmsfLoan;